import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '@Sage/hoi-poi-ui';

import { EntityCrudActions } from 'actions';
import { OPPORTUNITIES } from 'constants/Entities';
import DateField from 'containers/components/Fields/Date';
import { getActiveCrud } from 'utils/crud';
import { getLocaleStringFormat, getMomentFromDateBackend } from 'utils/dates';
import { logEvent } from 'utils/tracking';

const EXPECTED_CLOSE_FIELD = 'expectedCloseDate';

const OpportunityExpectedCloseInput = memo(({ readOnly, value }) => {
    const field = useRef('');

    const dispatch = useDispatch();
    const loadingSave = useSelector((state) => getActiveCrud(state)?.loadingSave);

    useEffect(() => {
        if (!loadingSave) field.current = '';
    }, [loadingSave]);

    const dateValue = useMemo(
        () => (value ? getMomentFromDateBackend(value).toDate() : null),
        [value],
    );

    const isLoading = loadingSave && field.current === EXPECTED_CLOSE_FIELD;

    const onChange = useCallback(
        (newValue) => {
            if (readOnly) return;
            if (!newValue && !value) return;
            if (
                getMomentFromDateBackend(newValue).format(getLocaleStringFormat().toUpperCase()) ===
                value
            )
                return;

            logEvent({
                event: 'opportunities',
                functionality: 'update',
                submodule: 'forecastDate',
            });
            field.current = EXPECTED_CLOSE_FIELD;
            const newData = {
                [EXPECTED_CLOSE_FIELD]: getMomentFromDateBackend(newValue).format('YYYY-MM-DD'),
            };
            dispatch(EntityCrudActions.changeFields(newData)).then(() => {
                dispatch(
                    EntityCrudActions.save({
                        entity: OPPORTUNITIES,
                        fieldsToUpdate: newData,
                        fromWorkFlow: false,
                        hasCrudInDetail: true,
                        openDetail: true,
                    }),
                );
            });
        },
        [dispatch, readOnly, value],
    );

    return (
        <div className="opportunity-expected-close-date">
            {isLoading && <Loader />}
            {!isLoading && <DateField onChange={onChange} readOnly={readOnly} value={dateValue} />}
        </div>
    );
});

OpportunityExpectedCloseInput.displayName = 'OpportunityExpectedCloseInput';

export default OpportunityExpectedCloseInput;
